import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GLOBAL } from 'src/app/app.globals';
import { SharedService } from 'src/app/core/services';
import { GatePassRequestsService } from '../gate-pass-requests.service';
import { AttendanceService } from 'src/app/attendance/attendance.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DynamicApicallService } from 'src/app/service/dynamic-apicall.service';
import { CommonService } from 'src/app/common/common.service';

@Component({
  selector: 'app-filter-popup',
  templateUrl: './filter-popup.component.html',
  styleUrls: ['./filter-popup.component.css']
})
export class FilterPopupComponent implements OnInit {
  public tabListFilter = [
    { id: 1, name: 'COMPANY', active: true },
    { id: 2, name: 'GATE PASS', active: false },
    { id: 3, name: 'CONTRACTOR', active: false },
    { id: 4, name: 'SUB-CONTRACTOR', active: false }
  ];

  @Input() public filter;
  isSelectedTabId: number = 1;
  roles = GLOBAL.ROLES;

  savedFilters: any[] = [];
  contractors: any[] = [];
  workOrders: any[] = [];
  ecPoliciesByWo: any[] = [];
  subContractors: any[] = [];
  plants: any[] = [];
  departments: any[] = [];
  workmanCategory: any[] = [];
  skills: any[] = [];
  months: any[] = [];
  leavetypes: any[] = [];
  statelist: any[] = [];
  licensesByWo: any[] = [];
  subLicenses: any[] = [];
  subWorkOrders: any[] = [];
  subEcPoliciesByWo: any[] = [];
  jobTypes: any[] = [];
  selectedContractors: any;
  selectedWorkOrder: string = '';
  selectedWorkOrderCode: number | null = null;
  selectedSubContractor: any;
  isActiveFilter: string = '';

  selectedPlant: any;
  selectedDepartment: any;
  selectedSkill: any;
  selectedWorkmanCategory: any;

  divRolecode = true;

  advanceFilterForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private gatePassRequestsService: GatePassRequestsService,
    public sharedService: SharedService,
    public attendanceService: AttendanceService,
    public apiCall: DynamicApicallService,
    private fb: FormBuilder,
    private commonService: CommonService,
  ) { }

  async ngOnInit() {
    this.getContractors();
    this.getStates();
    this.getLeaveType();
    this.getMonth();
    this.getAllDepartments();
    this.getAllPlants();
    this.getAllSkills();
    this.getAllWorkSiteCategories();
    this.isActiveFilter = this.tabListFilter[0].name;

    this.advanceFilterForm = this.fb.group({
      Plant: new FormControl(null),
      Department: new FormControl(null),
      Skill: new FormControl(null),
      workmanCategory: new FormControl(null),
      Search: new FormControl(null),
      ULC: new FormControl(null),
      Status: new FormControl(null),
      Role: new FormControl(null),
      roleActionCode: new FormControl(null),
      labourdemandtype: new FormControl(null),
      gatePassStatus: new FormControl(null),
      filterstartdate: new FormControl(null),
      filterenddate: new FormControl(null),
      Contractor: new FormControl(null),
      WorkOrder: new FormControl(null),
      License: new FormControl(null),
      ESIC: new FormControl(null),
      ECPolicyCheck: new FormControl(null),
      ECPolicy: new FormControl(null),
      SubContractor: new FormControl(null),
      SubWorkOrder: new FormControl(null),
      SubLicense: new FormControl(null),
      SubESIC: new FormControl(null),
      SubECPolicyCheck: new FormControl(null),
      SubECPolicy: new FormControl(null),
    });

    this.commonService.getJobTypes().subscribe((response)=>{
      this.jobTypes = response[0].Values;
      if (this.jobTypes.length === 1) {
        this.advanceFilterForm.controls['labourdemandtype'].setValue(this.jobTypes[0].MasterItem_Code);
      }
    });
  }

  public onTabFilter(tab: any): void {
    this.isSelectedTabId = tab.id;
    this.isActiveFilter = tab.name;
    this.tabListFilter.forEach((item) => item.active = item.id === tab.id);
  }

  getContractors() {
    this.attendanceService.getContractors().subscribe((response: any[]) => {
      this.contractors = response || [];
    });
  }

  getWorkOrders(contractorCode: any): void {
    this.workOrders = [];
    this.attendanceService.getWorkOrdersByContractorCode(contractorCode, undefined).subscribe((response: any) => {
      this.workOrders = response;
    });
  }

  getStates(): void {
    this.gatePassRequestsService.getAllState().subscribe((response: any) => {
      this.statelist = response;
    });
  }

  getLeaveType(): void {
    this.gatePassRequestsService.getLeaveTypeData().subscribe((response: any) => {
      this.leavetypes = response;
    });
  }

  getMonth(): void {
    this.gatePassRequestsService.getMonth().subscribe((response: any) => {
      this.months = response;
    });
  }

  getAllDepartments() {
    this.gatePassRequestsService.getALLDepartments().subscribe((response: any) => {
      this.departments = response.Data || response || [];
    });
  }

  getAllWorkSiteCategories() {
    this.gatePassRequestsService.getALLWorkSiteCategories().subscribe((response: any[]) => {
      this.workmanCategory = response.filter((list) => list.Parent_Code === 858);
    });
  }

  getAllPlants() {
    this.gatePassRequestsService.getALLPlants().subscribe((response: any) => {
      this.plants = response.Data || response || [];
    });
  }

  getAllSkills() {
    this.gatePassRequestsService.getALLSkills().subscribe((response: any) => {
      this.skills = response.Data || response || [];
    });
  }

  onContractorChange(selectedContractor: any) {
    this.selectedContractors = selectedContractor;

    this.advanceFilterForm.patchValue({ SubContractor: null });
    this.advanceFilterForm.patchValue({ WorkOrder: null });
    this.advanceFilterForm.patchValue({ License: null });
    this.advanceFilterForm.patchValue({ SubWorkOrder: null });
    this.advanceFilterForm.patchValue({ SubLicense: null });
    
    if (selectedContractor.ContractorVendor_Code) {
      this.getWorkOrders(selectedContractor.ContractorVendor_Code);
      this.getLicenseBySubContractors(selectedContractor.ContractorVendor_Code);
    } else {
      this.workOrders = [];
    }
  }
  
  onWorkOrderChange(selectedWorkOrder: any) {
    this.selectedWorkOrder = selectedWorkOrder.WorkOrderNo;
    this.selectedWorkOrderCode = selectedWorkOrder.WorkOrder_Code;

    this.advanceFilterForm.patchValue({ SubContractor: null });
    this.advanceFilterForm.patchValue({ SubWorkOrder: null });
    this.advanceFilterForm.patchValue({ License: null });
    this.advanceFilterForm.patchValue({ SubLicense: null });
    this.getWorkOrderBySubContractors();
  }

  getWorkOrderBySubContractors(): void {
    this.attendanceService.getSubContractors(this.selectedContractors.ContractorVendor_Code, this.selectedWorkOrderCode).subscribe((response: any[]) => {
      this.subContractors = response;
    });
  }
  
  onSubContractorChange(selectedSubContractor: any) {
    this.selectedSubContractor = selectedSubContractor
    this.advanceFilterForm.patchValue({ SubWorkOrder: null });
    this.advanceFilterForm.patchValue({ SubLicense: null });
    this.getSubWorkOrder();
  }
 
  selectedSubWorkOrder:any
  onSubWorkOrderChange(selectedSubWorkOrder: any) {
    this.selectedSubWorkOrder = selectedSubWorkOrder
  }
 
  getSubWorkOrder(): void {
    let params: any = {
      Contractor_Code: this.selectedContractors.ContractorVendor_Code,
      SubContractor_Code: this.selectedSubContractor.ContractorVendor_Code,
      WorkOrder_Code: this.selectedWorkOrderCode,
      UserId: GLOBAL.USER_ID,
    }

    this.apiCall.callApi('Common/List/SP_Listing_WorkOrder_Filter', 'POST', { body: params}).subscribe((response) => {
      this.subWorkOrders = response;
    });
  }

  getLicenseBySubContractors(contractorCode): void {
    this.attendanceService.getLicenses(contractorCode).subscribe((response: any[]) => {
      this.licensesByWo = response;
    });
  }

  onSaveFilter(){

  }

  onSubmitAdvanceFilter() {
    const formValues = this.advanceFilterForm.value;
    const filterObject = {
      Departmentcode: formValues.Department ? formValues.Department : null,
      Skilltypecode: formValues.Skill ? formValues.Skill : null,
      FilterStartDate: formValues.filterstartdate ? formValues.filterstartdate : null,
      FilterEndDate: formValues.filterenddate ? formValues.filterenddate : null,
      LabourDemandType: formValues.labourdemandtype ? formValues.labourdemandtype : null,
      GatePassStatus: formValues.gatePassStatus ? formValues.gatePassStatus : null,
      Licensecode: formValues.License ? formValues.License : null,
      MultipleRole: GLOBAL.ROLE_CODE,
      RoleCodeForApproval: formValues.Role ? formValues.Role : null,
      Roleactioncode: formValues.roleActionCode ? formValues.roleActionCode :null,
      Contractorvendorcode: formValues.Contractor ? formValues.Contractor : null,
      Subcontractorcode: this.selectedSubContractor ? this.selectedSubContractor.ContractorVendor_Code : null,
      Subworkordercode: formValues.SubWorkOrder ? formValues.SubWorkOrder : null,
      Sublicensecode: formValues.SubLicense ? formValues.SubLicense : null,
      Subecpolicycode: formValues.SubECPolicyCheck ? formValues.SubECPolicyCheck : null,
      UserCode: GLOBAL.USER_ID,
      UserRoleCode: JSON.parse(GLOBAL.ROLE)[0].Role_Code,
      WcPolicy: null,
      Mainesic: formValues.ECPolicyCheck ? formValues.ECPolicyCheck : null,
      Ecpolicycode: formValues.ECPolicy ? formValues.ECPolicy : null,
      Search: formValues.Search ? formValues.Search :null,
      Workordercode: formValues.WorkOrder ? formValues.WorkOrder :null,
      WorkSiteCategory: formValues.workmanCategory ? formValues.workmanCategory :null,
      Statecode: formValues.Status ? formValues.Status :null,
      Plantcode: formValues.Plant_code ? formValues.Plant_code :null,
      ULC: formValues.ULC ? Number(formValues.ULC) :null,
    };
    this.activeModal.close(filterObject);
    this.resetFilter();
  }

  resetFilter() {
    this.selectedPlant = null;
    this.selectedDepartment = null;
    this.selectedSkill = null;
    this.selectedWorkmanCategory = null;
    this.filter.search = '';
    this.filter.ulc = '';
    this.filter.statusCode = null;
    this.filter.roleCodeForApproval = null;
    this.filter.roleActionCode = null;
    this.filter.labourDemandType = null;
    this.filter.gatePassStatus = false;
    this.filter.filterStartDate = null;
    this.filter.filterEndDate = null;
    this.selectedContractors = null;
    this.selectedWorkOrder = null;
    this.selectedSubContractor = null;
    this.filter.subWorkOrder = null;
  }

  onCloseAction(): void {
    this.resetFilter();
    this.activeModal.close();
  }
}
